import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  Col,
  Hyperlink,
  Icon,
  Row,
} from '@openedx/paragon';
import { CheckCircle, CloseSmall } from '@openedx/paragon/icons';
import { getConfig } from '@edx/frontend-platform';

import './UpsellTable.scss';
import messages from './messages';

const UpsellTable = ({ isFBE, learningAssistantEnabled }) => {
  const intl = useIntl();
  return (
    <Col className="px-4 pb-4 small">
      <h3 className="mb-4 primary-500">
        {intl.formatMessage(messages.tableSectionHeader)}
      </h3>
      <Row className="m-0 text-center">
        <Col>
          <span className="sr-only">
            {intl.formatMessage(messages.featureHeader)}
          </span>
        </Col>
        <Col className="audit-cell top-audit-border col-2 ">
          <div className="center-items">
            {intl.formatMessage(messages.auditHeader)}
          </div>
        </Col>
        <Col className="verified-cell top-verified-border font-weight-bold col-2">
          <div className="center-items">
            {intl.formatMessage(messages.verifiedHeader)}
          </div>
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="feature-cell">
          {intl.formatMessage(
            messages.certificate,
            {
              certificateLink: (
                <Hyperlink destination={`${getConfig().MARKETING_SITE_BASE_URL}/verified-certificate`}>
                  {intl.formatMessage(messages.certificateLinkText)}
                </Hyperlink>
              ),
            },
          )}
        </Col>
        <Col className="audit-cell col-2">
          <div className="center-items">
            <Icon src={CloseSmall} alt={intl.formatMessage(messages.notIncludedAltMessage)} />
          </div>
        </Col>
        <Col className="verified-cell col-2">
          <div className="center-items">
            <Icon src={CheckCircle} alt={intl.formatMessage(messages.includedAltMessage)} />
          </div>
        </Col>
      </Row>
      {isFBE && (
        <Row className="m-0">
          <Col className="feature-cell">
            {intl.formatMessage(messages.grades)}
          </Col>
          <Col className="audit-cell col-2 center-items">
            <Icon src={CloseSmall} alt={intl.formatMessage(messages.notIncludedAltMessage)} />
          </Col>
          <Col className="verified-cell col-2 center-items">
            <Icon src={CheckCircle} alt={intl.formatMessage(messages.includedAltMessage)} />
          </Col>
        </Row>
      )}
      {learningAssistantEnabled && (
        <Row className="m-0">
          <Col className="feature-cell">
            <span>
              {intl.formatMessage(messages.learningAssistant)}
            </span>
          </Col>
          <Col className="audit-cell col-2 center-items">
            <Icon src={CloseSmall} alt={intl.formatMessage(messages.notIncludedAltMessage)} />
          </Col>
          <Col className="verified-cell col-2 center-items">
            <Icon src={CheckCircle} alt={intl.formatMessage(messages.includedAltMessage)} />
          </Col>
        </Row>
      )}
      <Row className="m-0">
        <Col className="feature-cell bottom-no-border flex align-items-center pb-3">
          {intl.formatMessage(messages.access)}
        </Col>
        <Col className="audit-cell bottom-audit-border col-2 pb-3 center-items">
          <Icon src={CloseSmall} alt={intl.formatMessage(messages.notIncludedAltMessage)} />
        </Col>
        <Col className="verified-cell bottom-verified-border col-2 center-items pb-3">
          <Icon src={CheckCircle} alt={intl.formatMessage(messages.includedAltMessage)} />
        </Col>
      </Row>
    </Col>
  );
};

UpsellTable.defaultProps = {
  isFBE: false,
  learningAssistantEnabled: false,
};

UpsellTable.propTypes = {
  isFBE: PropTypes.bool,
  learningAssistantEnabled: PropTypes.bool,
};

export default UpsellTable;
